import { useTranslation } from "react-i18next";
import { useState } from "react";
import "./style.css";

const News = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const categories = [
    { id: 1, name: t("news.categories.market"), number: "01" },
    { id: 2, name: t("news.categories.blockchain"), number: "02" },
    { id: 3, name: t("news.categories.compliance"), number: "03" },
    { id: 4, name: t("news.categories.analysis"), number: "04" },
    { id: 5, name: t("news.categories.announcements"), number: "05" },
  ];

  const handleCategoryClick = (categoryId: number) => {
    setSelectedCategory(categoryId);
  };

  return (
    <>
      {/* Hero Section */}
      <section className="news-hero">
        <div className="news-hero-content">
          <h1 className="font-bauhaus-medium">{t("news.title")}</h1>
          <p className="font-tomorrow">{t("news.subtitle1")}</p>
          <p className="font-tomorrow">{t("news.subtitle2")}</p>
        </div>
      </section>

      {/* Categories Section */}
      <section className="news-categories">
        <div className="categories-container">
          <h2 className="font-bauhaus-medium">{t("news.categoriesTitle")}</h2>
          <div className="categories-line">
            {categories.map((category) => (
              <div 
                key={category.id} 
                className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
              >
                <div className="category-number">{category.number}</div>
                <h3 className="font-tomorrow">{category.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Coming Soon Section */}
      {selectedCategory && (
        <section className="news-coming-soon">
          <div className="coming-soon-content">
            {/* <div className="coming-soon-icon">📰</div> */}
            <h2 className="font-bauhaus-medium">{t("news.comingSoon.title")}</h2>
            <p className="font-tomorrow">{t("news.comingSoon.description")}</p>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="news-cta">
        <div className="news-cta-content">
          <h2 className="font-bauhaus-medium">{t("news.cta.title")}</h2>
          <button className="btn-primary cursor-pointer">
            {t("news.cta.button")}
          </button>
        </div>
      </section>
    </>
  );
};

export default News;
